<template lang="pug">
  //- UI Button ----------------------------------------------------------------
  component(
    v-bind="buttonParams"
    :class="buttonClasses"
    @click="clickAction"
  ) {{ text }}
    //- UI Button loader -------------------------------------------------------
    transition(name="fade"): span.button-loader(v-if="loaderStatus")
      span.bouncer: i(v-for="num in 3" :class="'bounce-' + num")
</template>

<script>

export default {
  name: 'UiButton',

  // Component props -----------------------------------------------------------
  props: {

    // UI button text (required param)
    text: {
      type: String,
      required: true,
      default: 'OK'
    },

    // Button type
    type: {
      type: String,
      default: 'button',
      validator: function (value) {
        return ['button', 'submit', 'reset'].indexOf(value) !== -1
      }
    },

    // UI button status (optional param)
    isDisabled: {
      type: Boolean,
      default: false
    },

    // UI button loading status (optional param)
    isLoading: {
      type: Boolean,
      default: false
    },

    // UI button style (optional param)
    buttonStyle: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['default', 'outline', 'simple'].indexOf(value) !== -1
      }
    },

    // href
    _href: {
      type: String,
      default: ''
    },
    // title
    _title: {
      type: String,
      default: ''
    }
  },

  // Computed ------------------------------------------------------------------
  computed: {

    // Create full class name
    buttonStyleClass () {
      return 'ui-btn-' + this.buttonStyle
    },

    // Create full class list for button
    buttonClasses () {
      return [
        { 'ui-btn-a': !!this._href },
        'ui-btn',
        this.buttonStyleClass,
        { 'ui-btn-loading': this.loaderStatus }
      ]
    },

    // Button params
    buttonParams () {
      return {
        is: this._href ? 'a' : 'button',
        ...(!this._href && {
          disabled: this.isDisabled,
          type: this.buttonType
        }),
        ...(this._href && {
          href: this._href,
          title: this._title,
          target: '_blank',
          rel: 'noopener noreferrer'
        })
      }
    },

    // Validated loader status
    loaderStatus () {
      return this.isLoading && !this.isDisabled
    },

    // Button type
    buttonType () {
      return this.isDisabled || this.isLoading
        ? 'button'
        : this.type
    }
  },

  // Component methods ---------------------------------------------------------
  methods: {

    // Button clicked method
    clickAction () {
      // Prevent click event when disabled or loading
      if (this.isDisabled || this.isLoading) return
      // Other way emit event
      this.$emit('ui-btn-click')
    }
  }
}
</script>
